import React, {Component, Fragment} from "react";
import * as R from "ramda"
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import InventoryUnitTable from "./InventoryUnitTable";
import InventoryPageDetailHistory from "./InventoryPageDetailHistory";
import {fetchDataDetail} from "../service";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class InventoryPageDetail extends Component {

    tableConfig = [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
            const { page, rowsPerPage } = tableMeta.tableState;
            const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

            return <>{rowNumber}</>;
          },
          sort: false,
        },
      },
      ...this.props.pageConfig.detail.tableConfig,
      {
        name: "",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => {
            return (
              <FlexView vAlignContent="center">
                <SimpleButton
                  category="action_button"
                  icon={
                    <i
                      style={{ fontSize: 24, color: "red" }}
                      className="fa fa-lg fa-history"
                    />
                  }
                  onClick={() =>
                    this.handleModalHistoryVisibility(tableMeta.rowData)
                  }
                />
              </FlexView>
            );
          },
          setCellProps: () => ({
            style: { width: "5%" },
          }),
          sort: false,
        },
      },
    ];

    constructor(props) {
        super(props);
        this.initialSearch = {
            qrCode: null,
        };
        this.state = {
            dataTable: [],
            historyModalVisible: false,
            search: this.initialSearch,
            selectedData: null,
            rawDataTable: [],
            pagination: {
                count: 0,
                limit: 5,
                page: 1,
            },
        }
    }

    componentDidMount() {
        fetchDataDetail(this.props.type, this.setState.bind(this), this.props.selectedData, this.props.setError);
    }

    handleModalHistoryVisibility = (rowData) => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedData: {
                ...prevValue.dataTable.find(item => item.qrCode === (rowData ? rowData[1] : null)),
                ...this.props.selectedData,
            },
            historyModalVisible: !prevValue.historyModalVisible,
        }));
    }

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    wildcardToRegex=(pattern)=> {
      const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regexPattern = escaped.replace(/%/g, '.*');
      return new RegExp(`^${regexPattern}$`, 'i');
    }


    filterObjectsWithWildcard = (data, property, pattern)=>{
      if (!pattern) return data;
        
      const regex = this.wildcardToRegex(pattern);
      return data.filter(item => {
        const value = item[property];
        return value && regex.test(String(value));
      });
    }

    handleSubmitSearch = async () => {
        if (!R.isNil(this.state.search.qrCode) && !R.isEmpty(this.state.search.qrCode)) {
            const dataSearch = this.state.search.qrCode ?
                this.filterObjectsWithWildcard(this.state.rawDataTable,"qrCode",this.state.search.qrCode) :
                this.state.rawDataTable
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: dataSearch
            }));
        } else {
            await fetchDataDetail(this.props.type, this.setState.bind(this), this.props.selectedData);
        }
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title={this.props.pageConfig && this.props.pageConfig.detail.pageTitle}
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                                <div id="grid-1">
                                    {this.props.pageConfig && this.props.pageConfig.detail.firstGrid.map(
                                        (field) => (
                                            <SimpleInput
                                                key={field.name}
                                                id={`input_text_${field.name}`}
                                                name={field.name}
                                                label={field.label}
                                                readOnly={true}
                                                value={this.props.selectedData[field.name]}
                                            />
                                        ))
                                    }
                                </div>

                                <div id="grid-2">
                                    {this.props.pageConfig && this.props.pageConfig.detail.secondGrid.map(
                                        (field) => (
                                            <SimpleInput
                                                key={field.name}
                                                id={`input_text_${field.name}`}
                                                name={field.name}
                                                label={field.label}
                                                readOnly={true}
                                                value={this.props.selectedData[field.name]}
                                            />
                                        ))
                                    }
                                </div>
                            </div>

                            <FlexView style={{justifyContent: "flex-end"}}>
                                <p className="margin-top-5px margin-right-5px">QR Code</p>
                                <input
                                    id="input_search"
                                    type="text"
                                    name="qrCode"
                                    className="txt txt-sekunder-color margin-bottom-15px width width-250px"
                                    onChange={(e) => this.handleValueChange(e.target.name, e.target.value)}
                                />
                                <SimpleButton
                                    onClick={() => this.handleSubmitSearch()}
                                    styles={{width: "unset", marginBottom: "15px", marginLeft: "unset"}}
                                    icon={<i className={"fa fa-search"}></i>}
                                />
                            </FlexView>
                            <SimpleDataTable
                                key={`${this.state.pagination.count}-${this.state.pagination.page}`}
                                data={this.state.dataTable}
                                columns={this.tableConfig}
                                rowsPerPage={this.state.pagination.limit}
                                toCount={this.state.pagination?.count}
                                page={this.state.pagination.page - 1}
                                options={{
                                    ...defaultTableChange( this.handleChangePage, this.handleRowsPerPage ),
                                    serverSide: false,
                                }}
                            />
                            <div style={{textAlign: "right", marginTop: "10px"}}>
                                <SimpleButton
                                    onClick={() => this.props.onClickClose()}
                                    secondary
                                    text={"Keluar"}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.historyModalVisible && (
                    <InventoryPageDetailHistory
                        type={this.props.type}
                        setError={this.props.setError}
                        pageConfig={this.props.pageConfig}
                        selectedData={this.state.selectedData}
                        visible={this.state.historyModalVisible}
                        onClickClose={this.handleModalHistoryVisibility}
                    />
                )}
            </Fragment>
        );
    }
}

export default InventoryPageDetail;